import request from '#/utils/request';
import { keysToCamel, keysToSnake } from '#/api/adapters/wireCase';

/**
 * 依庫存 id 一次對照目前餘額。
 * POST `/inv/inventory-stock/lookup`（`inv.inventory_stock.lookup`）。
 * 對不到的 id 在 `missingIds`，不出現在 `data`。
 *
 * @param {string[]} ids
 */
export async function fetchInventoryStockLookup(ids) {
  const { data: raw } = await request.post(
    '/inv/inventory-stock/lookup',
    keysToSnake({ ids }),
  );
  const body = keysToCamel(raw ?? {});
  return {
    message: body.message,
    route: body.route,
    data: Array.isArray(body.list) ? body.list : [],
    missingIds: Array.isArray(body.missingIds) ? body.missingIds : [],
  };
}
